<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 custom-title">Guide Notifications</h3>
        </div>
    </div>
    <div class="section text-center" v-if="loading_page">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <ul class="listview image-listview inset mt-1" v-if="!loading_page">
        <li v-for="not in responseData.notifications" v-bind:key="not.id" :class="not.read_at?'active':''" style="position: relative;">
            <div class="item notification-item">
                <div 
                    class="icon-box bg-primary expand-icon-btn" 
                    @click.stop="toggleExpand(not.id)"
                    :title="expandedNotifications.includes(not.id) ? 'Show less' : 'Show more'"
                >
                    <ion-icon 
                        :name="expandedNotifications.includes(not.id) ? 'arrow-up-outline' : 'arrow-down-outline'" 
                        role="img" 
                        class="md hydrated"
                    ></ion-icon>
                </div>
                <div class="in notification-content" @click="handleNotificationClick(not)" style="cursor: pointer;">
                    <div>
                        <div class="mb-05 notification-title"><strong>{{not.data.title}}</strong></div>
                        <div class="notification-description" :class="{'expanded': expandedNotifications.includes(not.id)}">
                            {{not.data.description}}
                        </div>
                        <div class="text-xsmall text-primary mt-05">{{getFormattedDate(not.created_at)}}</div>
                    </div>
                </div>
                <button class="delete-btn" @click.stop="clearNotification(not.id)">
                    <ion-icon name="trash-outline"></ion-icon>
                </button>
            </div>
        </li>
    </ul>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import $ from "jquery";
import UserService from "../../services/user.service";
import NotificationService from "../../services/notification.service";
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import moment from 'moment'
export default {
    name: "Admin List",
    props: {
        unit_id: null
    },
    components: {
        AlertModel,
        DialogModel,
    },
    data() {
        return {
            loading: false,
            loading_page: false,
            user_level: "",
            user_level_id: "",
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            permissions: {
                edit: true
            },
            responseData: {
                notifications: []
            },
            expandedNotifications: [] // Track which notifications are expanded
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        childLength() {
            return parseInt(this.formData.lessthan_16_count);
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.$root.updateParent("Notifications");
            this.user_level = this.currentUser.user_level;
            if (this.user_level == 1) {
                this.user_level_id = 0;
            } else if (this.user_level == 2) {
                this.user_level_id = this.currentUser.district_id;
            } else if (this.user_level == 3) {
                this.user_level_id = this.currentUser.zone_id;
            } else if (this.user_level == 4) {
                this.user_level_id = this.currentUser.unit_id;
            }
            this.getData();
            
            // Request notification permission when user visits notifications page
            this.requestNotificationPermission();
        }

        window.onpopstate = function() {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        handleNotificationClick(not) {
            if (not.data.link) {
                window.open(not.data.link, '_blank');
            } else {
                this.notificationClick(not.id);
            }
        },
        getFormattedDate(date) {
            return moment(date).fromNow(); // Shows: "2 minutes ago", "1 hour ago"
        },
        getData() {
            this.loading_page = true;
            
            UserService.authGetRequest('notifications/user').then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.permissions = response.data.data.permissions;
                    }
                    this.loading_page = false;
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.loading_page = false;
                }
            );
        },
        notificationClick(id){
            let data = {
                id: id
            }
            UserService.authPostRequest('notifications/mark-as-read', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.getData();
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        
        async requestNotificationPermission() {
            try {
                const token = await NotificationService.requestPermission();
                if (token) {
                    console.log('Push notification permission granted and token received');
                    // Setup foreground message listener
                    NotificationService.setupForegroundMessageListener();
                    // Test notification (remove this in production)
                    setTimeout(() => {
                        NotificationService.testNotification();
                    }, 2000);
                } else {
                    console.log('Push notification permission denied');
                }
            } catch (error) {
                console.error('Error requesting notification permission:', error);
            }
        },
        toggleExpand(notificationId) {
            const index = this.expandedNotifications.indexOf(notificationId);
            if (index > -1) {
                // Collapse: remove from expanded list
                this.expandedNotifications.splice(index, 1);
            } else {
                // Expand: add to expanded list
                this.expandedNotifications.push(notificationId);
            }
        },
        clearAllNotifications() {
            this.responseData.notifications = [];
        },
        clearNotification(id) {
            // Optimistically remove notification from UI
            const originalNotifications = [...this.responseData.notifications];
            this.responseData.notifications = this.responseData.notifications.filter(n => n.id !== id);
            
            UserService.authPostRequest('notifications/delete', { id }).then(
                (response) => {
                    if (response.data.status !== 'success') {
                        this.$refs.alert_model.showAlert('error', 'Failed to delete notification.');
                        // Restore notifications if failed
                        this.responseData.notifications = originalNotifications;
                    }
                },
                () => {
                    this.$refs.alert_model.showAlert('error', 'Error deleting notification.');
                    // Restore notifications if error
                    this.responseData.notifications = originalNotifications;
                }
            );
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    margin-bottom: 20px;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    color: #060606;
}

/* Notification Item Styling */
.notification-item {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    transition: background-color 0.2s ease;
}

.notification-item:hover {
    background-color: #f8f9fa;
}

.expand-icon-btn {
    cursor: pointer;
    transition: transform 0.2s ease, background-color 0.2s ease;
}

.expand-icon-btn:hover {
    transform: scale(1.05);
    background-color: #1558d6 !important;
}

.expand-icon-btn:active {
    transform: scale(0.95);
}

.notification-content {
    flex: 1;
    padding-right: 40px;
    min-width: 0;
}

.notification-title {
    font-size: 15px;
    color: #1a1a1a;
    line-height: 1.4;
}

.notification-description {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    margin: 6px 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    max-height: 20px;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.notification-description.expanded {
    max-height: 500px;
    -webkit-line-clamp: unset;
    line-clamp: unset;
    display: block;
}

.delete-btn {
    position: absolute;
    top: 12px;
    right: 16px;
    padding: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.delete-btn:hover {
    transform: scale(1.1);
}

.delete-btn ion-icon {
    font-size: 22px;
    color: #d9534f;
}

.mt-05 {
    margin-top: 4px;
}

.mb-05 {
    margin-bottom: 4px;
}

/* Unread notification indicator */
.listview > li:not(.active) {
    background-color: #f0f7ff;
    border-left: 3px solid #1a418c;
}

.listview > li.active {
    opacity: 0.85;
}
</style>
